import Button from '@mui/material/Button';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '@fortawesome/fontawesome-free/css/all.min.css';

import './Login.scss';
import { useGameReducer } from '../../Store';
import { UserActions } from '../../Store/Actions';

export const LoginWithCode =  () => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');

  const [error, setError] = useState(false);

  const gameReducer = useGameReducer();

  useEffect(() => {
    if (gameReducer.token) {
      UserActions.getUserDetails();
    }
  }, [gameReducer.token]);

  const handleChange = (event) => {
    return setCode(event.target.value);
  };

  const login = () => {
    setError(false);
    if (code) {
      UserActions.loginWithCode(code).catch(() => {
        setError(true);
      });
    } else {
      setError(true);
    }
  };

  return (
    <div className='login_div'>
      <input
        id='code'
        type='text'
        name='code'
        className='input_box'
        placeholder={t('login.accessCode')}
        value={code}
        onChange={handleChange}
      />
      <Button variant='contained' className='header_btn' onClick={login}>
        {t('login.submitButton')}
      </Button>
      { error && (
        <div className='error_message'>
          <div className="subject">{t('login.errorOnCode')}</div>
          <div className="message">{t('login.errorOnCode.description')}</div>
        </div>
      )}
    </div>
  );
};
